import React from 'react';
import { services } from '../data/mock';
import { Pencil, FileText, Factory, Check } from 'lucide-react';

const serviceIcons = {
  'Collection Design': Pencil,
  'Technical Development': FileText,
  'Vendor Management & Production Oversight': Factory,
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-24 lg:py-32 bg-[#3D3D3D]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="font-inter text-xs tracking-[0.3em] uppercase text-[#C4B5A4]">
            What I Offer
          </span>
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-light text-[#FAF8F5] mt-4">
            Services
          </h2>
          <div className="w-12 h-[1px] bg-[#8B7355] mx-auto mt-6" />
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = serviceIcons[service.title] || Pencil;
            return (
              <div
                key={service.id}
                className="group bg-[#4A4A4A] hover:bg-[#5A5A5A] p-8 lg:p-10 transition-all duration-500 relative overflow-hidden"
              >
                {/* Service Number */}
                <span className="absolute top-6 right-6 font-playfair text-6xl text-[#5A5A5A] group-hover:text-[#6A6A6A] transition-colors duration-500">
                  0{index + 1}
                </span>

                {/* Icon */}
                <div className="w-14 h-14 flex items-center justify-center border border-[#8B7355] text-[#C4B5A4] mb-6 group-hover:bg-[#8B7355] group-hover:text-[#FAF8F5] transition-all duration-500">
                  <IconComponent size={24} strokeWidth={1.5} />
                </div>

                {/* Title */}
                <h3 className="font-playfair text-xl lg:text-2xl text-[#FAF8F5] mb-4">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="font-inter text-sm text-[#A8A8A8] leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* Features */}
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li
                      key={featureIndex}
                      className="flex items-start gap-3 font-inter text-xs text-[#C4B5A4]"
                    >
                      <Check
                        size={14}
                        className="text-[#8B7355] mt-0.5 flex-shrink-0"
                        strokeWidth={2}
                      />
                      {feature}
                    </li>
                  ))}
                </ul>

                {/* Hover Line */}
                <div className="absolute bottom-0 left-0 w-0 h-[2px] bg-[#8B7355] group-hover:w-full transition-all duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
